import { STOModel } from "src/models/base/sto-model";
import { OutgoingMailDTO } from "src/models/outgoing-mail";
import { BaseApiService } from "../base";

export class DiscardOutgoingMailApiService extends BaseApiService<OutgoingMailDTO, STOModel> {
  constructor() {
    super({
      servicePath: "/OutgoingMail",
      loadItemsPath: "/DiscardOutgoingMails",
    });
  }
}
